module.exports = __webpack_public_path__ + "static/album-img2-28d88ccb8b4a06b1b26c033f2f540d93.jpg";